import { DatePipe } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { WidgetsServiceService } from 'src/app/modules/home/widgets-collection/widgets-service.service';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../../../services/entities-service.service';

@Component({
  selector: 'app-dover-vitals-history',
  templateUrl: './dover-vitals-history.component.html',
  styleUrls: ['./dover-vitals-history.component.css'],
})
export class DoverVitalsHistoryComponent
  implements OnInit, OnDestroy, OnChanges
{
  @Input() periodFilter: any;
  @Input() tabData: any;
  @Input() genericFilter: any;
  columnHeader: any = {
    sourceTimestamp: 'Time',
    'Respiratory Rate': 'RR(BPM)',
    'Skin Temperature °C': 'ST(℃)',
    Activity: 'Activity(%)',
    value: 'Note',
    author: 'Added By',
    timestamp: 'Added On',
    action: 'Action',
  };
  vitalsHistoryConfig: any = {};
  transformedVitalData: any[] = [];
  isloader: boolean = true;
  activeUsersList: any[] = [];
  startTime: any;
  today: any = new Date();
  subscription: any;
  previousDate: any = null;
  currentPage: any = 1;
  totalPages: any;
  pagesData: any;
  pager: any = {};

  private _activeUsersList: any[] = [];
  private _subscription: Subscription;
  private _currentPage: any = 1;
  private _totalPages: any;
  private _activeUsersSubscription: Subscription;
  private _activeEntityDetailsSubscription: Subscription;
  private _updateEntityDataSubscription: Subscription;

  constructor(
    private _service: WidgetsServiceService,
    private _sharedService: ServicecallService,
    private _entityService: EntitiesServiceService,
    private _datePipe: DatePipe,
    private _dataSer: DataService
  ) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh') {
        this._activeUsers();
      }else if(res.name === 'pageSizeChange'){
        this._currentPage=1;
      }
    });
  }

  ngOnInit(): void {
    this.vitalsHistoryConfig = this._sharedService.getConfiguration(
      'tenantGenericConfig'
    )
      ? this._sharedService.getConfiguration('tenantGenericConfig')
      : null;
  }

  ngOnChanges(): void {
    this._activeUsers();
  }
  doverTableAction(event: any) {
    if (event?.type === 'submit') {
      const reqData = {
        data: {
          notes: {
            value: event?.formValue?.note,
            author: event?.formValue?.name,
            timestamp: this._datePipe.transform(
              new Date(),
              'yyyy-MM-ddTHH:mm:ssZ'
            ),
          },
          attrValid: event?.formValue?.flag,
        },
        _id: event?.item?._id,
      };
      this._updateEntityDataSubscription = this._entityService
        .updateEntityData(reqData)
        .subscribe((result: any) => {
          if (result['status']) {
            this._sharedService.toasterService({
              type: 'success',
              msg: result?.response?.message,
            });
            this.isloader = true;
            this._dataSer.broadcast('vitalHistoryRefresh');
            this._activeEntityDetails(this._currentPage);
          } else {
            this._sharedService.toasterService({
              type: 'error',
              msg: result?.response?.message,
            });
          }
        });
    } else {
      this._activeEntityDetails(event);
    }
    // else if (event?.type === 'next') {
    //   this.previousDate = this.transformedVitalData[this.transformedVitalData.length - 1]?.sourceTimestamp;
    //   this.previousDate ? this.activeEntityDetails('next') : '';
    // } else if (event?.type === 'previous') {
    //   this.activeEntityDetails();
    // }
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
    this._activeUsersSubscription?.unsubscribe();
    this._activeEntityDetailsSubscription?.unsubscribe();
    this._updateEntityDataSubscription?.unsubscribe();
  }

  private _activeUsers() {
    this.isloader = true;
    this._activeUsersSubscription = this._entityService
      .activeUsers()
      .subscribe({
        next: (result: any) => {
          if (result['status']) {
            if (result['response']['data']?.length) {
              let transformedUserList = [];
              [...result['response']['data']].forEach((item: any) => {
                const transformedCurrentObj =
                  this._sharedService.flattenObject(item);
                transformedUserList.push(transformedCurrentObj);
              });
              this._activeUsersList = transformedUserList;
              transformedUserList = [];
            } else {
              this._activeUsersList = [];
            }
          } else {
            this._activeUsersList = [];
            this._sharedService.toasterService({
              type: 'error',
              msg: result?.response?.message,
            });
          }
          this._activeEntityDetails(this._currentPage);
        },
        error: (error) => {
          if (error) {
            this._activeUsersList = [];
          }
          this._activeEntityDetails(this._currentPage);
        },
      });
  }
  private _activeEntityDetails(pageNo?: number) {
    this._currentPage = pageNo ? pageNo : this._currentPage;
    const requestData = {
      siteId: this._sharedService.getSiteId(),
      entityCategory: 'patient',
      from: this._datePipe.transform(
        this.genericFilter?.startTime,
        'yyyy-MM-ddTHH:mm:ssZZ'
      ),
      to: this._datePipe.transform(
        this.genericFilter?.endTime ? this.genericFilter?.endTime : Date.now(),
        'yyyy-MM-ddTHH:mm:ssZZ'
      ),
      entityId: this.tabData?.entityId,
      count: this.genericFilter?.pageSize,
    };
    this._activeEntityDetailsSubscription = this._service
      .activeEntityDetails(requestData, pageNo)
      .subscribe({
        next: (result: any) => {
          if (result['status']) {
            if (result['response']['data']?.length) {
              let transformedCurrentData = [];
              [...result['response']['data']].forEach((item: any) => {
                const transformedCurrentObj = this._sharedService.flattenObject(
                  item,
                  'vitals'
                );
                transformedCurrentObj['usersList'] = this._activeUsersList;
                transformedCurrentData.push(transformedCurrentObj);
              });
              this.transformedVitalData = transformedCurrentData;
              transformedCurrentData = [];
            } else {
              this.transformedVitalData = [];
            }
            this.clearUnwantedValues();
            if (result['response']['pageInfo']) {
              this.pager = { ...result['response']['pageInfo'] };
            } else {
              this._totalPages = [];
              this.pager = {};
            }
          } else {
            this.transformedVitalData = [];
            this._sharedService.toasterService({
              type: 'error',
              msg: result?.response?.message,
            });
          }
          this.isloader = false;
        },
        error: (error) => {
          if (error) {
            this.transformedVitalData = [];
            this.isloader = false;
          }
        },
      });
  }

  clearUnwantedValues() {
    if (this.vitalsHistoryConfig?.vitalsHistoryTableHeader) {
      const tableHeaderKeys = Object.keys(
        this.vitalsHistoryConfig?.vitalsHistoryTableHeader
      );
      tableHeaderKeys.push('usersList', 'attrValid', '_id');
      if (tableHeaderKeys?.length) {
        this.transformedVitalData?.forEach((item: any) => {
          const keysList = Object.keys(item);
          if (keysList?.length) {
            keysList?.forEach((key: any) => {
              if (!tableHeaderKeys?.includes(key?.toString())) {
                delete item[key];
              }
            });
          }
        });
      }
    }
  }
}
